import { render, staticRenderFns } from "./VolumeEfficiencyDiagram.vue?vue&type=template&id=1fb6a07c&scoped=true&"
import script from "./VolumeEfficiencyDiagram.vue?vue&type=script&lang=js&"
export * from "./VolumeEfficiencyDiagram.vue?vue&type=script&lang=js&"
import style0 from "./VolumeEfficiencyDiagram.vue?vue&type=style&index=0&id=1fb6a07c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb6a07c",
  null
  
)

export default component.exports